// REQUIRED IMPORTS
import run from '../../utilities/run';
const $ = require('jquery');
import render from "../../utilities/render";
import addressValidationFactory from '../common/AddressValidation.js';
import { setElementsFromScope, show, hide} from '../../utilities/selectorHelpers';
require("./selfOnboarding.less");
// Additional Imports...
let done;
var enableUserEnteredAddressRadioForSPL =true;
var disableSubmitAddressBtnIfInvalidAddressForSPL = true;

const modalHtml = require("../../sharedHtml/modal.html");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { createPreventDefault } from '../../utilities/general';
import { create } from 'underscore';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import EditChecker from '../../components/EditChecker/EditChecker';
import { data } from 'jquery';
import { isNull, isNullOrUndefined, isNumber } from 'util';
import { isBlank } from "../../utilities/general";

const elementsMap = {
  configDoneBtn: ".submit-facility-setup-wizard",
  createBtn: ".create-btn",
  addReasonBtn: ".add-reason-btn",
  defaultProductBtn: ".default-prodct-btn",
  emailShippingAddressBtn: ".email-shipping-address-btn",
  editAccountAddressSection: ".edit-account-address-section",
  saveAccountAddressBtn:".save-account-address-btn",
  saveAccountAddressContinueBtn:".save-account-address-continue",
  copyTextLink: ".copy-text",
  address1:".ret-address1",
  address2:".ret-address2",
  city:".ret-city",
  zipcode:".ret-zip-code",
  state:".ret-state",
  country:".ret-country"
}

const elsModalMap = {
  editAddressBtn: ".edit-address-btn"
}

const targetSelector = "#fedex-accounts-configuration-production";
// Modal Html to use

run(targetSelector, (el)=>{
  attachStubExample(el);
  setupEditChecker(el);
});

function setupEditChecker(el){
  var alertTab = true;
  
  $('.qw-nav-step').each(function(){
    var tabValue =  $(this).attr('data-qw-form-target');
    if (tabValue === '.so-summary-tab') {
      alertTab = false;
    }
  });
  if(alertTab){
    $(window).on('beforeunload', function(){
      return 'Are you sure you want to leave?';    
  });
  }
}

export default function attachStubExample(el) {
  let facilitySetupWizard, addressErrorModal, saveAccountAddressModal;
  let submitModalFlow;

  const els = {};
  const elsModal = {};

  // START: REQUIRED TO LOAD STUB
  const entryEl = $("<div class='entry-point'></div>");
  const mainHtml = render(
    require("./html/selfOnboarding.html"), {
    accounts: require("./html/accounts-production.html"),
    locations: require("./html/locations.html"),
    products: require("./html/products.html"),
    returnConfigurations: require("./html/returnConfigurations.html"),
    summary: require("./html/summary.html"),
  });

  const mainEl = $(mainHtml);
  $(el).html(entryEl);
  entryEl.append(mainEl);
  const saveFedexAccountUrl = el.data("save-fedex-account-url");
  const saveAccountAddressUrl = el.data("save-account-address-url");
  const addressValidationUrl = el.data("address-validation-url");
  const saveFacilityDetailsUrl = el.data("save-facility-details-url");
  const facNameCheckUrl = el.data("fac-name-check-url")
  const facIdCheckUrl = el.data("fac-id-check-url");
  const retailerName = el.data("retailer-name");
  const retailerWebUrl = el.data("retailer-web-url");
  const retailerAddress1 = el.data("retailer-address1");
  const retailerAddress2 = el.data("retailer-address2");
  const retailerCity = el.data("retailer-city");
  const retailerState = el.data("retailer-state");  
  const retailerZipCode = el.data("retailer-zip-code");
  const countryCode = el.data("retailer-country-code");
  const usaStates = el.data('usa-states'); 
  const caProvinces = el.data('ca-provinces'); 
  const addressStateSelect = $("#address-state");
  const addressValidationFor = el.data('address-validation-for');
  const addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
  const addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
  const validationReqdCountries = el.data('validation-reqd-countries');
  const defaultCountry = el.data('default-country');
  const CountryList = el.data('countries');
  const namespace = el.data('namespace');
  const retailerLandingPage = el.data('retailer-landing-tab');
  let activeSelfOnbaordTab = el.data("active-selfonbaordtab");
 // var visitedTab = new arrayOf();
  var allTabs = ["so-accounts-tab","so-locations-tab", "so-products-tab", "so-returnConfigurations-tab", "so-summary-tab"];
  var visitedTabs = [];
  //let activeSelfOnbaordTab = "so-products-tab";
  let visitedSelfOnboardTab = ["so-accounts-tab","so-locations-tab"];
  //Config Step 3 & 4 for prod
  const cdmShortValue = $(".return-reason-short-value").val();
  const cdmLongValue = $(".retunr-reason-display-value").val();
  
  const defaultProductsSwitchery = $('#international-shipping');
  let useDefaultItemFlagforProd = false;
  const defaultProductsUrl = el.data("default-products-url");

  const fedexBrandEmailSwitchery = $('#fedEx-branded-email');
  let prodEmailFlag = false;
  const emailShippingAddressUrl = el.data("email-shipping-address-url");

  const overrideShippingSwitchery = $('#show-ability-override');
  let prodOverrideShippingFlag = false;

  const overrideShippingAddressSwitchery = $('#show-ability-override-address');
  let prodShippingAddress = false;

  const returnReasonsUrl = el.data("return-reasons-url");
  let responseData;

  const sobConfigDoneEmailUrl = el.data("sob-config-done-url");
  let configComplete = true;

  // END: REQUIRED TO LOAD STUB

  // START: REAL CODE

  function init() {
    initQuickWizard();
    generateModals();
    setElementsInModals();
    setElements();
    bindElements();
    renderMerchantAddress();  
    ActiveTabFarward();
  }
  /*$( document ).ready(function() {
   ActiveTabFarward();
   console.log("Prodect elememt id" +document.getElementById("productTab"));
   console.log("prodct elemt html visisbilty" +document.getElementById("productTab").style.visibility);
    document.getElementById("productTab").style.visibility = "visible";
    }); */
 /*   window.onload = function(e){ 
      ActiveTabFarward();
   console.log("Prodect elememt id" +document.getElementById("productTab"));
   console.log("prodct elemt html visisbilty" +document.getElementById("productTab").style.visibility);
    document.getElementById("productTab").style.visibility = "visible";
   // document.getElementById("productTab").innerHTML = "New text!";
      
  } */
  function determineInActiveTab(activeSelfOnbaordTab, visitedTabs) {
    var index;
    console.log("before active self onbaord activeSelfOnbaordTab tabs!" +activeSelfOnbaordTab);
    console.log("before active self onbaord visitedTabs tabs!" +visitedTabs);
    for (index = 0; index < visitedTabs.length; ++index) {
      if (visitedTabs[index] === activeSelfOnbaordTab) {
        // visitedTabs.splice(index, 1);
        console.log("inside index valuse id!!!!!!" +index);
        visitedTabs.splice(index+1, 9e9);
        console.log("all visited tabs after!!!!" + visitedTabs);
        break;
      }
    }
  }
  function ActiveTabFarward(e) {
    console.log("Inside new activetab farward function");
    console.log("activeSelfOnbaordTab" +activeSelfOnbaordTab);
    if (!isNullOrUndefined(activeSelfOnbaordTab) && !isBlank(activeSelfOnbaordTab)) {
      
      visitedTabs =[].concat(allTabs);
      var inActiveTabs = determineInActiveTab(activeSelfOnbaordTab, visitedTabs);
      //var inActiveTabs = allTabs.filter(determineInActiveTab(activeSelfOnbaordTab, allTabs ))

      $('.qw-nav-step').each(function (index) {
        console.log("index" + index);

        document.getElementById("accountsTab").style.visibility = "hidden";
      var tabCssValue =  $(this).attr('data-qw-form-target');
      console.log('this is inside tabs list '+tabValue);
     // $(this).removeClass('active');
      /*if (tabValue === '.so-accounts-tab') {
        $(this).removeClass('active');
        $(this).addClass('visited');
      }*/

      var tabValue = tabCssValue.replace(".","");
      if(activeSelfOnbaordTab == tabValue) { 
        console.log("Inside locationtab active inside");
        //$(activeSelfOnbaordTab).add
        //$('.so-accounts-tab').addClass('visited'); 
        // document.getElementById("accountsTabForm").classList.remove('active');
        // document.getElementById("accountsTabForm").classList.add('visited');
        // document.getElementById("accountsTab").style.visibility = "hidden";
        // document.getElementById("locationTab").style.visibility = "visible";
        //e.preventDefault();
        $(this).addClass('active');
        var href = $(this).attr('href');
        console.log("href" +href);
       // $('#container').load(href);
        $('section').empty().load(href);
        //document.getElementById("accountsTabForm").classList.add('visited');
        //activeSelfOnbaordTab = '';
       
      }else if($.inArray(tabValue, visitedTabs) != -1){

        $(this).addClass('visited');
        $(this).removeClass('active');
        
      } else {
        $(this).removeClass('active');
      }
    
    });
   /* try {
    $(".self-tab").each(function(){
      debugger;
        console.log("Check has class :  "+$(this).hasClass(activeSelfOnbaordTab));
        console.log("class Info:  "+$(this).attr('class'));
        document.getElementById("accountsTab").style.visibility = "hidden";
        if($(this).hasClass(activeSelfOnbaordTab)){
          console.log("Inside if  Info:  "+$(this).attr('class'));
           $(this).css("visibility", "visible");
         $(this).css("transform", "none");
         throw BreakException;
        }else{
          console.log("Inside else Info:  "+$(this).attr('class'));
          $(this).css("visibility", "hidden");
        }
    }); } catch (e) {
      if (e !== BreakException) throw e;
    } */

    }
}

  function setElements() {
    setElementsFromScope(els, elementsMap, mainEl);
  }

  function setElementsInModals() {
    const body = $('body');
    setElementsFromScope(elsModal, elsModalMap, body);
  }

  function bindElements() {
    //els.doneBtn.click(createPreventDefault(showSubmitModal));  
    els.createBtn.click(function(e) {
      e.preventDefault();
      saveFedexAccount({url: saveFedexAccountUrl, success: successOnSaveFedexAccount, error: errorOnSaveFedexAccount});
    });
    //Production Return reason list button function
    els.addReasonBtn.click(function (e) {
      e.preventDefault();
      console.log('Short value -->>' + $(".return-reason-short-value").val());
      console.log('display value-->>' + $(".retunr-reason-display-value").val());
      addReason({ url: returnReasonsUrl });
    });

    //production defult item swithch save 
    els.defaultProductBtn.click(function (e) {
      e.preventDefault();
      console.log('default switch -->>');  
      saveDefaultProducts({ urlDf: defaultProductsUrl });
    });

    // send email once config is done 
    els.configDoneBtn.click(function (e) {
      e.preventDefault();
      console.log('config done -->>');  
      sendConfigDoneEmail({ configDoneurl: sobConfigDoneEmailUrl });
    });
    
   // branded email, default shipping override and address 
    els.emailShippingAddressBtn.click(function (e) {
      e.preventDefault();
      console.log('emailShippingAddressBtn -->>');  
      saveEmailShippingAddress({ urlEsa: emailShippingAddressUrl });
    });

    els.copyTextLink.click(createPreventDefault(copyToClipboard));    
    els.saveAccountAddressBtn.click(createPreventDefault(validateAddress));
    els.saveAccountAddressContinueBtn.click(createPreventDefault(saveAccountAddress));
    elsModal.editAddressBtn.click(createPreventDefault(showAccountInfoModal));
  }
  
   // production: prevent previous button navigation
  function initQuickWizard() {
    facilitySetupWizard = new QuickWizard(mainEl, {     
      tabletWidthNavStep: 1090,
      mobileWidthNavStep: 950,
      shouldNavigateToForm: ({ targetForm, direction, currentForm, done }) => {
          // Any time we go traverse backwards, just let us  
          console.log('-->2 '+currentForm.filter(".so-products-tab").length);
          if(currentForm.filter(".so-products-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||(targetForm.filter(".so-locations-tab").length)){
              direction = "BACKWARDS";
            }
          }

          if(currentForm.filter(".so-returnConfigurations-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||(targetForm.filter(".so-locations-tab").length)||(targetForm.filter(".so-products-tab").length)){
              direction = "BACKWARDS";
            }
          }

          if(currentForm.filter(".so-summary-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||
            (targetForm.filter(".so-locations-tab").length)||(targetForm.filter(".so-products-tab").length)||(targetForm.filter(".so-returnConfigurations-tab").length)){
              direction = "BACKWARDS";
            }
          }

      if (direction === "BACKWARDS") {    
        return false;
      }

      // if (direction === "FORWARDS") {  
      //   console.log(currentForm.filter(".accounts-prod-btn").length);
      //   if (currentForm.filter(".accounts-prod-btn").length !== 0) {
      //     return false;
      //   } else{ 
      //     return true;
      //   }
 
      // }
        return true;
      },
      
      didNavigateToForm: ({ currentForm }) => {      
        return true;       
      }
    });
    
    facilitySetupWizard.init();
    
    $(document).on('click', "[data-target-form]", function () {      
      const form = mainEl.find($(this).data("target-form"));      
      facilitySetupWizard.gotToForm(form);
    });
  
  }


  function generateModals() {
   
    submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Save Facility',
      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
      confirmModalBtnText: 'Save',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        // Show Loading Modal
        submitModalFlow.showLoadingModal();

        // Success
        setTimeout(function () {
          submitModalFlow.showSuccessModal();
        }, 3000);

        // Hide All Modals
        setTimeout(function () {
          submitModalFlow.hideAllModals();
        }, 6000);
      }
    });

    submitModalFlow.init();

    addressErrorModal = $(render(
      modalHtml, {
      title: 'Registration Error Details',
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-activate-rule modal-auto-hide">Cancel</a>\
          <a href="#" class="base-btn purple-btn edit-address-btn">Edit Address</a>',
      body: "<div class='q-marg-all-xl'>There appears to be an issue with FedEx Meter services while registering the given Fedex Account Number. <div><br/>Validate the Account Number, Registered Address match, and if they do not match click the edit address button to correct the issue.</div></div>",
      topCloseBtn: true,
      autoHideTop: true,
      leftAlignTitle: true,
      modalDialogClass: "q-modal-dialog-500"
    }
    ));

    saveAccountAddressModal = $(render(
      modalHtml, {
      title: 'Save Account Address',
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a>\
          <a href="#" class="base-btn purple-btn save-account-address-continue">Continue</a>',
      body: "<div class='q-marg-all-xl'>Please continue to save the account address.</div></div>",
      topCloseBtn: true,
      autoHideTop: true,
      leftAlignTitle: true,
      modalDialogClass: "q-modal-dialog-500"
    }
    ));

    $('body').append(addressErrorModal, saveAccountAddressModal);

  };

  function showSubmitModal() { 
    submitModal.showConfirmModal();
  }
    function sendConfigDoneEmail({ configDoneurl }) {
      {
        $.ajax({
          data: {
            "configComplete": configComplete   
          },
          url: configDoneurl,
          dataType: 'JSON',
          type: 'POST',
          success: function (data) {
            console.log('config done '+ data.status );    
            console.log('config done email ajax ' + JSON.stringify(data)); 
            
            console.log('in show submit');    
            let myUrl =   "/c/portal/logout";
            window.open(myUrl, '_self', '');
            console.log('in show submit-- '+myUrl); 
          }
        });
      }
    }  
 

  //Send email once the config is done



  function showAccountInfoModal() {
    submitModalFlow.hideAllModals();
    addressErrorModal.modal("hide");
    els.editAccountAddressSection.show();
  }

  function showAddressErrorModal() {
    //submitModalFlow.hideAllModals();
    addressErrorModal.modal("show");
    
  }

  $("#save-account-address-cancel").click(function(){
    $("#confirmationBoxToSaveAccountAddress").modal("hide");
  });
  $("#save-account-address-continue").click(function(){
    $("#confirmationBoxToSaveAccountAddress").modal("hide");
    saveAccountAddress();    
  });

  function renderStates(retailerState){
    $(usaStates).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      if(retailerState===this.cdmValue)
      {
        option.attr('selected','selected');
      }
      $('#address-state').append(option);
    });
  }

  function renderCountry(countryCode){
    console.log("countryCode" +countryCode);
    $(CountryList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conCode).text(this.conName);
      if(countryCode===this.conCode)
      {
        option.attr('selected','selected');
      }
      $('#selfAccountCountry').append(option);
    });
  }

  $(CountryList).each(function(){
    var option = $('<option />');
    option.attr('value', this.conCode).text(this.conName);
    //option.attr('value', this.cdmValue).text(this.cdmMeaning);
    $('#selfLocationCountry').append(option);
  });

  $('#selfLocationCountry').change(function(){
    var countryVal = $('#selfLocationCountry option:selected').val();
    setStates(countryVal);
  });

  function setStates(countryVal) {
    $('#selfLocationState').html('');
    var option = $('<option />');
    option.attr('value', "-1").text('Select State/Province/Region');
    option.attr('selected','selected');
    option.attr('disabled','disabled');
    let checkZipCode = false;
      $(CountryList).each(function() {
        if(this.conCode.toString() === countryVal.toString()) {
            if(this.conPostalCodeRequired.toString() === "Y"){
              checkZipCode=true;
            }
        }
      });
    if(countryVal == "US" && checkZipCode) {
      $('#selfLocationStateContainer').css("display", "block");
      $('#facstateTextContainer').css("display", "none");
      $('#facstateText').prop('required',false);
      $('#selfLocationState').prop('required',true);
      $('#selfLocationState').append(option);
      $(usaStates).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
      
        $('#selfLocationState').append(option);
      });
    } else if(countryVal == "CA" && checkZipCode) {
      $('#selfLocationStateContainer').css("display", "block");
      $('#facstateTextContainer').css("display", "none");
      $('#facstateText').prop('required',false);
      $('#selfLocationState').prop('required',true);
      $('#selfLocationState').append(option);
      $(caProvinces).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        $('#selfLocationState').append(option);
      });
    } else{
      $('#facstateText').prop('required',false);
      $('#selfLocationState').prop('required',false);
     $('#selfLocationStateContainer').css("display", "none");
     $('#facstateTextContainer').css("display", "block");
    }
  }

 $(".fac-loc-id").change(function(){
   console.log("inside duplicate fac id check ");
    validateFacilityId();
});
$(".fac-loc-name").change(function(){
  validateFacilityName();
});


  $('.add-location-btn').click(function(event){
    event.preventDefault();
    console.log("Inside acoount add button func");

    var requiredFields  = $('#saveLocationSection input, select').filter('[required]:visible');
    var allRequired =true;
    requiredFields.each(function(){
    $("#requriedFieldError").each(function(){
      $(this).remove();
  });
});
    requiredFields.each(function(){
        if($(this).val() == ''){
          allRequired=false;
          var error = '<label id="requriedFieldError" class="help-block" style="color: red;">The field is required !!</label>';
          $(this).after(error);
        }
    });
    console.log("allRequired is :" +allRequired);
    if(allRequired){
    const addressValidationModalEl = $("#add-validation-model");
    const addressValidationForSelfFacilityTab = addressValidationFactory(null, el, {
      isAlreadyValid: false,
      currentTab: ".so-locations-tab",
      disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
      disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
    });
    console.log("address value " +JSON.stringify(addressValidationForSelfFacilityTab.determineAddressValidity(done))); 
    console.log("Address Validation :  "+document.getElementById("addLocationFlagForAddressValidation").value +"     "+$("#addLocationFlagForAddressValidation").val());
    if(document.getElementById("addLocationFlagForAddressValidation").value == 'Validated')
    {
      //saveFacilityDetails();
    }

    $("#shipToLocations").css("display","none");
    $("#shipToLocationsEdit").css("display","none");
    viewFacilityDetails();

    $('.qw-nav-step').each(function(){
      
      var tabValue =  $(this).attr('data-qw-form-target');
      console.log('this is inside tabs list '+tabValue);
      if(tabValue === '.so-accounts-tab'){
        console.log('accounts tab hide');
            $(this).removeClass('active');
            $(this).addClass('visited');
      }
      if(tabValue === '.so-locations-tab'){
        console.log('location tab show');
        $(".loc-next-btn").removeClass('disabled');
        $(this).addClass('active');
        
  }
    });
  }
  });

  $('.loc-next-btn').click(function(event) {
    console.log("Inside Next Button loc screen");
    $(".loc-next-btn").removeClass('disabled');
    saveFacilityDetails();
  });
  $("#self-save-loc-cancel").click(function(){
    $("#saveSelfLocation").modal("hide");
  });
  $("#self-save-loc-continue").click(function(){
    saveFacilityDetails();
    $("#saveSelfLocation").modal("hide");
  });
    function saveFacilityDetails(){
      $('.fac-id-view').text($(".fac-loc-id").val());
      if($(".fac-country").val() == 'US' || $(".fac-country").val() == 'CA'){
         let facState = $(".fac-state").val();
      }else{
         let facState = $(".fac-state-text").val();
      }
      $.ajax({
        data: {
        "facilityid" :  $(".fac-loc-id").val(),
        "facilityname" : $(".fac-loc-name").val(),
        "facAddress1" : $(".fac-address1").val(),
        "facAddress2" : $(".fac-address2").val(),
        "facCity" : $(".fac-city").val(),
        "facState" : $(".fac-state").val(),
        "facZipcode" : $(".fac-zip-code").val(),
        "facCountry" : $(".fac-country").val(),
        "facContactname" : $(".fac-contactname").val(),
        "facEmail" : $(".fac-contact-email").val(),
        "facPhone" : $(".loc-contact-phone").val(),
        "facFedexAccount" : $(".fac-ship-acc-number").val()
           },
        url: saveFacilityDetailsUrl,
        dataType:"JSON",
        type: 'POST',

        success: function(response) {
          //var activeTab = $(".tabs").tabs( "option", "active" );
          submitModalFlow.showSuccessModal();
          setTimeout(function () { submitModalFlow.hideAllModals(); }, 100);
          $(".loc-next-btn").removeClass('enabled');
        // $("#shipToLocations").css("display","block");
         //$("#shipToLocationsEdit").css("display","block");
         $("#saveLocationSection").children().prop("disabled", true);
        // $("#saveLocationSection").css("dsiplay", "none");
        // $('.add-location-btn').attr('disabled','disabled');
         //$("#saveLocationSection").hide();
         //$(".loc-next-btn").removeAttr('disabled');
         document.getElementById("locNextBtn").disabled = false;
          console.log("insid sucess add fac function");
         //viewFacilityDetails();
        },     
        error: function(){
          $(".loc-next-btn").removeClass('disabled');
          submitModalFlow.showFailureModal();
        }
      });
  }

  $('.loc-edit').click(function(event) {
    console.log("Inside edit butto loca screen");
    //showFacility();
    event.preventDefault();
    //$("#saveLocationSection").css("dsiplay", "block");
    //$("#saveLocationSection").show();
    //document.getElementById("saveLocationSection").style.visibility = "visible";
    document.getElementById("saveLocationSection").style.display = "block";
    $('.add-location-btn').removeAttr('disabled');
    $('.fac-loc-id').prop("disabled", false);
    $('.fac-loc-name').prop("disabled", false);
    $('.fac-address1').prop("disabled", false);
    $('.fac-address2').prop("disabled", false);
    $('.fac-city').prop("disabled", false);
    $('.fac-state').prop("disabled", false);
    $('.fac-zip-code').prop("disabled", false);
    $('.fac-country').prop("disabled", false);
    $('.fac-contactname').prop("disabled", false);
    $('.fac-contact-email').prop("disabled", false);
    $('.loc-contact-phone').prop("disabled", false);
    $('.fac-ship-acc-number').prop("disabled", false);
  });

function viewFacilityDetails()
{
  //hideFacilty();
  //$("#saveLocationSection").css("dsiplay", "none");
  document.getElementById("noneAddedMsg").style.visibility = "hidden";
  $('.add-location-btn').attr('disabled','disabled');
  $('.fac-loc-id').prop("disabled", true);
  $('.fac-loc-name').prop("disabled", true);
  $('.fac-address1').prop("disabled", true);
  $('.fac-address2').prop("disabled", true);
  $('.fac-city').prop("disabled", true);
  $('.fac-state').prop("disabled", true);
  $('.fac-zip-code').prop("disabled", true);
  $('.fac-country').prop("disabled", true);
  $('.fac-contactname').prop("disabled", true);
  $('.fac-contact-email').prop("disabled", true);
  $('.loc-contact-phone').prop("disabled", true);
  $('.fac-ship-acc-number').prop("disabled", true);

  $('.fac-id-view').text($(".fac-loc-id").val());
  $('.fac-name-view').text($(".fac-loc-name").val());
  $('.fac-address1-view').text($(".fac-address1").val());
  $('.fac-address2-view').text($(".fac-address2").val());
  $('.fac-city-view').text($(".fac-city").val());
  $('.fac-state-view').text($(".fac-state").val());
  $('.fac-zipcode-view').text($(".fac-zip-code").val());
  $('.fac-country-view').text($(".fac-country").val());
  $('.fac-contactname-view').text($(".fac-contactname").val());
  $('.fac-contact-email-view').text($(".fac-contact-email").val());
  $('.fac-phone-view').text($(".loc-contact-phone").val());
  $('.fac-shipping-account-view').text($(".fac-ship-acc-number").val());
}

//collapse after save locations
function showFacility() {
  //debugger;
  console.log("in collapse");
  var x = document.getElementById("saveLocationSection"); 
    x.style.display = "block";      
}

function hideFacilty() {
  //debugger;
  console.log("in collapse");
  var x = document.getElementById("saveLocationSection");
    x.style.display = "none";   
  
}

//duplicate facility name check
function validateFacilityName() {
  const facName = $(".fac-loc-name").val();
  $.ajax({
      async: false,
      data: {
        facName:facName
      },
      url: facNameCheckUrl,
      dataType:"JSON",
      type: 'POST',
      success: function(data){
        if(data.response== true) {
          $(".dup-facName").show();  
        }else{
          $(".dup-facName").hide();
        }  
      }  
   });
}

function validateFacilityId() {
  console.log("inside check fac id ajax call");
  console.log("facIdCheckUrl is :" +facIdCheckUrl);
  const facId =   $(".fac-loc-id").val();
  $.ajax({
      async: false,
      data: {
        facId:facId
      },
      url: facIdCheckUrl,
      dataType:"JSON",
      type: 'POST',
      success: function(data){
        console.log("inside sucess go fac id " +data.response);
        if(data.response== true) {
          $(".dup-facId").show();
        }else{
          $(".dup-facId").hide();
        }  
      }  
   });

}
  //for copying text
  function copyToClipboard() {
    CopyToClipbrd("https://fulfillment.fedex.com", true, "URL copied");
  }

  function CopyToClipbrd(value, showNotification, notificationText) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();

    if (typeof showNotification === 'undefined') {
        showNotification = true;
    }
    if (typeof notificationText === 'undefined') {
        notificationText = "Copied to clipboard";
    }

    var notificationTag = $("div.copy-url-notification");
    if (showNotification && notificationTag.length == 0) {
        notificationTag = $("<div/>", { "class": "copy-url-notification", text: notificationText });
        $("body").append(notificationTag);

        notificationTag.fadeIn("slow", function () {
            setTimeout(function () {
                notificationTag.fadeOut("slow", function () {
                    notificationTag.remove();
                });
            }, 1000);
        });
    }
}

//let done;
const addressValidationModalEl = $("#add-validation-model");
function validateAddress() {
  var accountRequiredFields  = $('#editAddressSection input, select').filter('[required]:visible');
  var allRqd =true;

  accountRequiredFields.each(function(){
    $("#requriedFieldaccountError").each(function(){
      $(this).remove();
  });
});
accountRequiredFields.each(function(){
  if($(this).val() == ''){
    allRqd=false;
    var error = '<label id="requriedFieldaccountError" class="help-block" style="color: red;">The field is required !!</label>';
    $(this).after(error);
  }
});
  if(allRqd){
   // $("#requriedFieldError").remove();
  const addressValidationForAccountConfigurationTab = addressValidationFactory(null, el, {
    isAlreadyValid: false,
    currentTab: ".so-accounts-tab",
    disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
    disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
  });
 
  console.log("address value" +JSON.stringify(addressValidationForAccountConfigurationTab.determineAddressValidity(done)));
  //$("#confirmationBoxToSaveAccountAddress").modal("show");
}
}

/*$(".use-selected-address-btn").click(function(){
  saveAccountAddressModal.modal("show");
});*/


function saveAccountAddress(){
  submitModalFlow.showLoadingModal(); 
  $.ajax({
    data:{
        "address1": els.address1.val(),
        "address2": els.address2.val(),                          
        "city": els.city.val(),
        "state": els.state.val(),
        "zipcode": els.zipcode.val(),
    },
    url: saveAccountAddressUrl,
    dataType: 'JSON',
    type: 'POST',
    success: success,
    error: error
   });
}

function success(response){
  console.log('response.status  --'+response.status );
  if(response.status == "Success"){
    $(".accounts-prod-btn").removeClass('enabled');
   submitModalFlow.showSuccessModal();
   setTimeout(function () { submitModalFlow.hideAllModals(); }, 3000);
  }
  else
  {
    //$(".accounts-prod-btn").removeClass('disabled');
    submitModalFlow.showFailureModal();
  }
}

function error(){
  //$(".accounts-prod-btn").removeClass('disabled');
  submitModalFlow.showFailureModal();
}

function saveFedexAccount({url,success,error}){
  
  var accNumGiven =true;
  $("#requriedAccountFieldError").each(function(){
    $(this).remove();
});
  if($(".fedex-shipping-account-num").val()==='')
  {
    accNumGiven = false;
    var error = '<label id="requriedAccountFieldError" class="help-block" style="color: red;">The field is required !!</label>';
    $('.fedex-shipping-account-num').after(error); 
  }

  if(accNumGiven)
  {
    $("#requriedFieldError").remove();
    submitModalFlow.showLoadingModal();
    $.ajax({
        data:{
            "fedExShippingAccountNumber": $(".fedex-shipping-account-num").val(),
            "smartPostHubId": $(".smart-post-hub-id").val(),                          
        },
        url: url,
        dataType: 'JSON',
        type: 'POST',
        success: successOnSaveFedexAccount,
        error: errorOnSaveFedexAccount                 
    });
  }
  
}
function successOnSaveFedexAccount(response){
  setTimeout(function () { submitModalFlow.hideAllModals(); }, 3000);
  if(response.status == "Success"){
    document.getElementById("createBtnAccount").setAttribute("disabled", "disabled");
    $(".accounts-prod-btn").removeClass('disabled');
    $(".fac-ship-acc-number").val($(".fedex-shipping-account-num").val());
   submitModalFlow.showSuccessModal(); 
  }
  else
  {
    showAddressErrorModal();
  }
}
function errorOnSaveFedexAccount(){
  showAddressErrorModal();
  $(".accounts-prod-btn").removeClass('enabled');
}

$(".accounts-prod-btn").click(function(event){ 
  document.getElementById("saveLocationSection").style.display = "block";
  $("#completeFieldsMsg").css("display","block");
  $("#shipToLocations").css("display","none");
  $("#shipToLocationsEdit").css("display","none");
});
//Production Config step 3 default product 
defaultProductsSwitchery.on('change', function (e) {
  if (defaultProductsSwitchery.is(":checked")) {
    useDefaultItemFlagforProd = true;
    console.log('useDefaultItemFlagforProd ' + useDefaultItemFlagforProd);
  } else {
    useDefaultItemFlagforProd = false;
    console.log('useDefaultItemFlagforProd ' + useDefaultItemFlagforProd);
  }
});

//Production Config step 3  save default product
function saveDefaultProducts({ urlDf }) {
  debugger;
  {
    $.ajax({
      data: {
        "defaultProduct": useDefaultItemFlagforProd   
      },
      url: urlDf,
      dataType: 'JSON',
      type: 'POST',
      success: function (data) {
        console.log('res1 '+ data.status );    
        console.log('prod in defautl products ajax ' + JSON.stringify(data));  
      }
    });
  }
}

//Production Config step 4 Fedex Branded email swich 
fedexBrandEmailSwitchery.on('change', function (e) {
  if (fedexBrandEmailSwitchery.is(":checked")) {
    prodEmailFlag = true;
    console.log('prodEmailFlag ' + prodEmailFlag);
  } else {
    prodEmailFlag = false;
    console.log('prodEmailFlag ' + prodEmailFlag);
  }
});

//Production Config step 4 override default shipping swich 
overrideShippingSwitchery.on('change', function (e) {
  if (overrideShippingSwitchery.is(":checked")) {
    prodOverrideShippingFlag = true;
    console.log('prodOverrideShippingFlag ' + prodOverrideShippingFlag);
  } else {
    prodOverrideShippingFlag = false;
    console.log('prodOverrideShippingFlag ' + prodOverrideShippingFlag);
  }
});

//Production Config step 4 override ship to address swich 
overrideShippingAddressSwitchery.on('change', function (e) {
  if (overrideShippingAddressSwitchery.is(":checked")) {
    prodShippingAddress = true;
    console.log('prodShippingAddress ' + prodShippingAddress);
  } else {
    prodShippingAddress = false;
    console.log('prodShippingAddress ' + prodShippingAddress);
  }
});

//step 4 email ,default shipping and address ajax production
function saveEmailShippingAddress({ urlEsa }) {
  debugger;
  {
    $.ajax({
      data: {
        "fedexBrandedEmail": prodEmailFlag,
        "defaultShippingOverride": prodOverrideShippingFlag,  
        "shippingAddressOverride": prodShippingAddress,
        "defaultProduct": useDefaultItemFlagforProd        
      },
      url: urlEsa,
      dataType: 'JSON',
      type: 'POST',
      success: function (data) {
        console.log('in success '+ data.status );    
        console.log('prod email,orverride shipping,address ajax ' + JSON.stringify(data));  
      }
    });
  }
}

//Production Config step 4 adding return reason list
function addReason({ url }) {  
  {
    $.ajax({
      data: {
        "cdmValue": $(".return-reason-short-value").val(),
        "cdmMeaning": $(".retunr-reason-display-value").val(),
      },
      url: url,
      dataType: 'JSON',
      type: 'POST',
      success: function (response) {       
        responseData = response.data;
        console.log('prod in reason ajax ' + JSON.stringify(response.data));  

        console.log("cdmValue --> "+ responseData.cdmValue);
        console.log("cdmMeaning --> "+ responseData.cdmMeaning);
        if(responseData.cdmValue !== null && responseData.cdmMeaning !== null){
        document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue +'    '+ responseData.cdmMeaning + '</li>';  

       }   

       $(".return-reason-short-value").val('');
       $(".retunr-reason-display-value").val('');

      }      

      });       

  }
}


// success: function (response) {
//   debugger;
//   responseData = response.data;
//   console.log('prod in reason ajax ' + JSON.stringify(response.data));  

//  // response.data.forEach((obj, i) => {
//    // debugger;
//    // if (  response.data.length < 4 ){

//       document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue +'    '+ responseData.cdmMeaning + '</li>';            
//   //  }         
//     console.log("cdmValue --> "+ responseData.cdmValue);
//     console.log("cdmMeaning --> "+ responseData.cdmMeaning);
// });
// data.messages.map((obj, i) => {
//   console.log("msgFrom", obj.msgFrom);
//   console.log("msgBody", obj.msgBody);
// });

// function renderReturnReasons(retailerState){
//   $(usaStates).each(function(){
//     var option = $('<option />');
//     option.attr('value', this.cdmValue).text(this.cdmMeaning);
//     if(retailerState===this.cdmValue)
//     {
//       option.attr('selected','selected');
//     }
//     console.log(option);
//     $('#address-state').append(option);
//   });
//}

function renderMerchantAddress()
{
  els.editAccountAddressSection.hide();
  els.address1.val(retailerAddress1);
  els.address2.val(retailerAddress2);
  els.city.val(retailerCity);
  els.zipcode.val(retailerZipCode);
  $('.ret-country').val(countryCode);
  $('.merchant-name').val(retailerName);
  $('.merchant-name').prop("disabled", true);
  $('.merchant-web-url').val(retailerWebUrl);
  $('.merchant-web-url').prop("disabled", true);
  renderStates(retailerState);
  renderCountry(countryCode);
}
  init();

  // END: REAL CODE
};



// WEBPACK FOOTER //
// ./src/pages/rmaMerchantSelfOnboarding/rmaMerchantAccountConfigurationProduction.js